import React from 'react'
import SweetAlert from "sweetalert2-react";
import { Link, Redirect } from 'react-router-dom'

import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import TrashIcon from '@material-ui/icons/Archive';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import ForwardIcon from '@material-ui/icons/Forward';
import CalendarIcon from '@material-ui/icons/CalendarToday';
import DatePicker from "react-datepicker";
import Moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import { watchJournals, getJournals, 
  setJournalRowSelected, 
  setAllJournalRowsSelected, 
  archiveSelectedJournalsPopup, 
  assignSelectedJournalsPopup, 
  archiveSelected, 
  changeStatusPopup, 
  changeDueDatePopup, 
  setSelectedJournalStatus,
  setSelectedJournalAssignment,
  setSelectedDueDate } from 'store/actions/journalActions';
import { getAvailableAssignments } from 'store/actions/projectActions';
import ReactTable from "react-table";
import "react-table/react-table.css";
import Checkbox from "@material-ui/core/Checkbox"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip'


import GridContainer from "components/grid/GridContainer.js";

class JournalList extends React.Component {
  constructor(props) {
    super(props);
    //this.state = {
      //loading: true,
      //timestamp: "",
      //selectAll: false,
      //data: [],
      //checked: []
    //};
    //this.handleChange = this.handleChange.bind(this);
    //this.handleSingleCheckboxChange = this.handleSingleCheckboxChange.bind(
      //this
    //);

    this.state = {
      alert: null
    };
  }


  onRowClick = (state, rowInfo, column, instance) => {
    return {
        onClick: e => {
            console.log('A Td Element was clicked!')
            console.log('it produced this event:', e)
            console.log('It was in this column:', column)
            console.log('It was in this row:', rowInfo)
            console.log('It was in this table instance:', instance)
            if ((column.colIndex === undefined || column.colIndex !== 0) && (rowInfo !== undefined)){
        
              this.props.history.push({pathname: '/journal/'+rowInfo.original.ID});
            }
        }
    }
  };

  handleSingleCheckboxChange = (ev, checked) => {
    const index = ev.currentTarget.id;
    this.props.setJournalRowSelected(index, checked);
    
  };

  handleChange = (ev, checked) => {
    this.props.setAllJournalRowsSelected(checked);
    //var selectAll = !this.state.selectAll;
    //this.setState({ selectAll: selectAll });
    //var checkedCopy = [];
    //this.state.data.forEach(function(e, index) {
      //checkedCopy.push(selectAll);
    //});
    //this.setState({
      //checked: checkedCopy
    //});
  };

  
  closeCalendar = () => {
    this.props.changeDueDatePopup(false);
  }

  handleCalendarChange = (date) => {
    
    this.props.setSelectedDueDate(Moment(date).format('YYYY-MM-DD'));
    this.props.changeDueDatePopup(false);
  }

  archiveSelected = (ev) => {
    console.log("Archiving selected");
    this.props.archiveSelectedJournalsPopup(
    
          true)
    ev.currentTarget.blur();
     
  }

  archiveConfirmed = () => {
    console.log("Archiving selected");
    this.props.archiveSelected();
    this.hideArchiveAlert();
  }

  assignConfirmed = () => {
    console.log("Assign selected");
    this.props.assignSelected();
    this.hideAssignAlert();
  }

  hideArchiveAlert() {
    this.props.archiveSelectedJournalsPopup(false);
    
  }

  hideAssignAlert() {
    this.props.assignSelectedJournalsPopup(false);
  }

  hideStatusAlert() {
    this.props.changeStatusPopup(false);
  }

  hideDueDateAlert() {
    this.props.changeDueDatePopup(false);
  }

  hideArchiveAlert = () => {
    this.props.archiveSelectedJournalsPopup(false);
  } 

  hideAssignAlert = () => {
    this.props.assignSelectedJournalsPopup(false);
  }
    
  hideStatusAlert = () => {
    this.props.changeStatusPopup(false);
  }

  hideDueDateAlert = () => {
    this.props.changeDueDatePopup(false);
  }

  assignSelected = (ev) => {
    console.log("Assigning selected ");
    this.props.assignSelectedJournalsPopup(true, ev.currentTarget);
  }

  statusSelected = (ev) => {
    console.log("Change status for selected");
    this.props.changeStatusPopup(true, ev.currentTarget);
     
  }

  createDeadlineForSelected = (ev) => {
    console.log("Creating deadline for selected");
    this.props.changeDueDatePopup(true);
  }


  hasSelection() {
    if (this.props.journalRows === undefined || this.props.journalRows === null) {
      return false;
    }
    for (var i = 0; i < this.props.journalRows.length; i++) {
      if (this.props.journalRows[i] === true) {
        return true;
      }
      
    }
    return false;
  }

  handleClose = (ev, value) => {
    this.props.changeStatusPopup(false, null);
    if (ev.currentTarget.textContent !== null && ev.currentTarget.textContent !== undefined && ev.currentTarget.textContent.length > 0) {
      this.props.setSelectedJournalStatus(ev.currentTarget.textContent);
    }
  }

  handleAssignmentClose = (ev, value) => {
    this.props.assignSelectedJournalsPopup(false, null);
    if (ev.currentTarget.textContent !== null && ev.currentTarget.textContent !== undefined && ev.currentTarget.textContent.length > 0) {
      this.props.setSelectedJournalAssignment(ev.currentTarget.textContent);
    }
  }

  render() {
    const { journals, auth, selectedProject, alert, showChangeStatusPopup, showAssignPopup, menuAnchor, assignmentMenuAnchor, assignments, adminView } = this.props;
   //const {anchorEl, setAnchorEl} = this.state;
    if (!auth.uid) return <Redirect to='/signin' /> 

    if ((journals === null || journals === undefined) && (selectedProject !== null && selectedProject !== undefined)) {
      if (adminView) {
        this.props.getJournals(selectedProject.companyName, selectedProject.projectName);
      } else {
        this.props.watchJournals(selectedProject.companyName, selectedProject.projectName);
      }
      if ((assignments === null) || (assignments === undefined)) {
        this.props.getAvailableAssignments(selectedProject.companyName, selectedProject.projectName);
      }
    }
    return (
      <div>
      {  (<SweetAlert
            
            showCancelButton={true}
            show={this.props.showArchivePopup}
            
            onConfirm={this.archiveConfirmed}
            onCancel={this.hideArchiveAlert}
            
            text="Are you sure you wish to archive the selected tapes?" />)
        }
        { (
          <Menu id="simple-menu" anchorEl={menuAnchor} open={showChangeStatusPopup} onChanged={this.handleClose} onClose={this.handleClose}>
            <MenuItem value="Open" onClick={this.handleClose}>Open</MenuItem>
            <MenuItem value="Reopen" onClick={this.handleClose}>Reopen</MenuItem>
            <MenuItem value="Resolve" onClick={this.handleClose}>Resolve</MenuItem>
            <MenuItem value="Close" onClick={this.handleClose}>Close</MenuItem>
          </Menu>)
        }
        {  (<Menu id="simple-menu" anchorEl={assignmentMenuAnchor} open={showAssignPopup} onChanged={this.handleAssignmentClose} onClose={this.handleAssignmentClose}>
            { assignments && assignments.map(assignment => {
            return (
              <MenuItem value={assignment} onClick={this.handleAssignmentClose}>{assignment}</MenuItem>
                
            )
            })}  
            
          </Menu>)
        }
        {  this.props.showChangeDueDatePopup && (
            <DatePicker
                onClickOutside={this.closeCalendar}
                onChange={this.handleCalendarChange}
                withPortal
                inline
                dateFormat="yyyy-MM-dd" />
            )
        }
        
      <div style={{display: 'flex', flexDirection: 'row', padding: '0px', margin: '0px'}}>
      <FormControlLabel style={{margin: '0px', padding: '0px'}}
              
              control={
                <Tooltip title="Select All"><Checkbox style={{margin: '0px', color: 'green', height: '40px'}}
        onChange={this.handleChange.bind(this)}
        checked={this.props.journalsSelectAll}
      />
      </Tooltip>
      
              }/>
              
              {this.hasSelection() === true ? (
              <div style={{margin: '0px'}}>

              {this.adminView && (<Tooltip title="Archive"><IconButton style={{focusOutline: "none"}}><TrashIcon onClick={this.archiveSelected} style={{color: "grey", focusOutline: "none"}}/></IconButton></Tooltip>)}
              <Tooltip title="Change Status"><IconButton><DoneAllIcon onClick={this.statusSelected} style={{color: "grey"}}/></IconButton></Tooltip>
              <Tooltip title="Change Assignment"><IconButton><ForwardIcon onClick={this.assignSelected} style={{color: "grey"}}/></IconButton></Tooltip>
              <Tooltip title="Set Due Date"><IconButton><CalendarIcon onClick={this.createDeadlineForSelected} style={{color: "grey"}}/></IconButton></Tooltip>
              </div>) 
              : 
              (<div></div>)}
              </div>
    <ReactTable 
          //noDataText="Loading ..."
          data={journals === null ? [] : journals}
          defaultPageSize={10}
          columns= {[
            { Header: x => { 
              return(
                <div></div>
              );
            },
            Cell: row => {
              return (
              <FormControlLabel
                        
                        control={
              <Checkbox style={{margin: '0px', color: 'green', height: '0px'}}
                
                id={row.index}
                onChange={this.handleSingleCheckboxChange.bind(this)}
                checked={this.props.journalRows[row.index]}
              />
            }
            />
            ) },
            width: 40,
            sortable: false,
            filterable: false,
            colIndex: 0},
            {
              Header: "Tape ID",
              accessor: "tapeID",
              width: 120,
              sortable: false,
              filterable: false
            },
            {
              Header: "Location",
              accessor: "locationHierarchy",
              width: 200,
              sortable: false,
              filterable: false
            },
            {
              Header: "Preview",
              accessor: "logText[0].en",
             
              sortable: false,
              filterable: false
            },
            {
              Header: "Assignment",
              accessor: "assignedTo",
              width: 140,
              sortable: false,
              filterable: false
            },
            {
              Header: "Status",
              accessor: "status",
              width: 90,
              sortable: false,
              filterable: false
            },
            {
              Header: "Due Date",
              accessor: "dueDate",
              width: 90,
              sortable: false,
              filterable: false
            }
          ]}
          getTdProps={this.onRowClick}
         
        
          />
          </div>
    
    )
  }
}

const mapDispatchToProps = dispatch => {
    return {
      
          watchJournals: (companyName, projectName) => dispatch(watchJournals(companyName, projectName)),
          
          getJournals: (companyName, projectName) => dispatch(getJournals(companyName, projectName)),
          setJournalRowSelected: (journalRow, selected) => dispatch(setJournalRowSelected(journalRow, selected)),
          setAllJournalRowsSelected: (selected) => dispatch(setAllJournalRowsSelected(selected)),
          archiveSelectedJournalsPopup: (popup) => dispatch(archiveSelectedJournalsPopup(popup)),
          assignSelectedJournalsPopup: (popup, anchor) => dispatch(assignSelectedJournalsPopup(popup, anchor)),
          changeStatusPopup: (popup, anchor) => dispatch(changeStatusPopup(popup, anchor)),
          changeDueDatePopup: (popup) => dispatch(changeDueDatePopup(popup)),
          archiveSelected: (popup) => dispatch(archiveSelected(popup)),
          setSelectedJournalStatus: (status) => dispatch(setSelectedJournalStatus(status)),
          setSelectedJournalAssignment: (assignment) => dispatch(setSelectedJournalAssignment(assignment)),
          setSelectedDueDate: (date) => dispatch(setSelectedDueDate(date)),
          getAvailableAssignments: (companyName, projectName) => dispatch(getAvailableAssignments(companyName, projectName))
    }
  }
  
  
const mapStateToProps = (state) => {
    console.log(state);
    const journals = state.journal.journals;
    return {
      auth: state.firebase.auth,
      journals: journals,
      selectedProject: state.project.selectedProject,
      journalRows: state.journal.journalRows,
      journalsSelectAll: state.journal.journalsSelectAll,
      showArchivePopup: state.journal.showArchivePopup,
      showAssignPopup: state.journal.showAssignPopup,
      showChangeStatusPopup: state.journal.showChangeStatusPopup,
      showChangeDueDatePopup: state.journal.showChangeDueDatePopup,
      menuAnchor: state.journal.menuAnchor,
      assignments: state.project.assignments,
      assignmentMenuAnchor: state.journal.assignmentMenuAnchor,
      adminView: state.user.adminView
    }
  }
  
  export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firebaseConnect([
      'tapes'
    ])
  )(JournalList)




// WEBPACK FOOTER //
// ./src/components/journals/JournalList.js